/**
 * @file 获取圈子 setup
 */
import { API_TYPE, fetchData } from '@umu/umu-fetch';

export enum SetupType {
    circle = '1',
    topic = '2',
}

export interface IInput {
    obj_type?: SetupType; // 1:学习圈 （默认1） 2: 主题相关 11 企业设置
    obj_id: string;
    setting_keys?: string;
}

export interface IOutput {
    [key: string]: number;
}

/**
 * 获取学习圈设置
 */
const GET_CIRCLE_SETUP = {
    url: '/uapi/v1/learning-circle/settings',
    type: API_TYPE.GET,
};

export const getCircleSettings = (data: IInput): Promise<IResponse<IOutput>> => {
    if (!data.obj_type) {
        data.obj_type = SetupType.circle;
    }
    return fetchData(GET_CIRCLE_SETUP, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
